import { OrderDetailPage } from 'pages/orders/detail';

export const OrderDetailView = () => {
  return <OrderDetailPage />;
}
